import { RowCrudStatus } from "../../common/types";
import {
  CollectiveManagementSociety,
  CollectiveManagementSocietyCreateMutationVariables,
  CollectiveManagementSocietyUpdateMutationVariables,
} from "../../../api/graphql";
import { LangStore } from "../../../store";
import { countryDisplayId } from "../../country/store/CountryCommonStore";

export type CollectiveManagementSocietyValuesType = {
  id: string;
  displayId: string;
  version_: string;
  __status__: RowCrudStatus;
  name: string;
  acronym: string;
  __country: string;
  showCountry: { displayId: string; id: string } | null;
};

export type CollectiveManagementSocietyErrorsType = {
  name?: { message: string; fieldLabel: string };
  acronym?: { message: string; fieldLabel: string };
  country?: { message: string; fieldLabel: string };
};

export function CollectiveManagementSocietyValuesInit(): CollectiveManagementSocietyValuesType {
  return {
    id: "",
    displayId: "",
    version_: "",
    __status__: "empty",
    name: "",
    acronym: "",
    __country: "",
    showCountry: null,
  };
}

export type CollectiveManagementSocietyType =
  | CollectiveManagementSociety
  | CollectiveManagementSocietyValuesType;

export function collectiveManagementSocietyDisplayId(
  source: Partial<CollectiveManagementSociety>,
  _langStore: LangStore
) {
  return source.acronym ?? _langStore.emptyStringSymbol;
}

export function getCollectiveManagementSocietyValues(
  source: CollectiveManagementSocietyType,
  _langStore: LangStore,
  _duplicated: boolean = false
): CollectiveManagementSocietyValuesType {
  const entityValues = CollectiveManagementSocietyValuesInit();
  entityValues.id = source.id;
  entityValues.displayId =
    "__status__" in source
      ? source.displayId
      : collectiveManagementSocietyDisplayId(source, _langStore);
  entityValues.version_ = source.version_;
  entityValues.name = source.name;
  entityValues.acronym = source.acronym;
  entityValues.showCountry =
    "country" in source && source.country
      ? {
          id: source.country.id,
          displayId: countryDisplayId(source.country, _langStore),
        }
      : "showCountry" in source && source.showCountry
      ? { id: source.showCountry.id, displayId: source.showCountry.displayId }
      : null;
  entityValues.__country = entityValues.showCountry?.displayId || "";
  if (_duplicated) {
    entityValues.__status__ = "added";
  } else if ("__status__" in source) {
    entityValues.__status__ = source.__status__;
  }
  return entityValues;
}

export function getCollectiveManagementSocietyUpdateVariables(
  values: CollectiveManagementSocietyValuesType
): CollectiveManagementSocietyUpdateMutationVariables {
  return {
    id: values.id,
    version_: values.version_,
    name: values.name,
    acronym: values.acronym,
    countryId: values.showCountry?.id || "",
  };
}

export function getCollectiveManagementSocietyCreateVariables(
  values: CollectiveManagementSocietyValuesType
): CollectiveManagementSocietyCreateMutationVariables {
  return {
    name: values.name,
    acronym: values.acronym,
    countryId: values.showCountry?.id || "",
  };
}
